import React, { useState } from "react";
import { KeyRound, Clock } from 'lucide-react';
import { Box, Typography, Grid, Card, CardContent, Button, Dialog, DialogContent } from '@mui/material';
import PasswordStrength from '../Company/PasswordStrength';
import PasswordRequirements from '../Company/PasswordRequirements';
import { Edit } from '@mui/icons-material'; // Edit icon
import { userSelector } from "../../../user-redux/selector";
import { useDispatch, useSelector } from "react-redux";
import Candidateprofile from "../../Candidateprofile";
import Recruterprofile from "../../Recruiterprofile";
import AdminProfilesettings from "../../Adminprofilesettings";


const PasswordSection = () => {
    const { user } = useSelector(userSelector);
    const [openDialog, setOpenDialog] = useState(false);
    const [showPasswordSettings, setShowPasswordSettings] = useState(false); // State for password settings

    // Handlers for opening and closing the dialog
    const handleOpenDialog = () => setOpenDialog(true);
    const handleCloseDialog = () => setOpenDialog(false);
    const [isEditClicked, setIsEditClicked] = useState(false);

    // Render the content dynamically based on the usertype
    const renderDialogContent = () => {
        if (user?.usertype == 6) {
            return <Candidateprofile showPasswordSettings={1} setIsEditClicked={setIsEditClicked} />;
        } else if (user?.usertype == 3) {
            return <Recruterprofile showPasswordSettings={1} setIsEditClicked={setIsEditClicked} />;
        } else if (user?.usertype == 7 || user?.usertype == 13) {
            return <AdminProfilesettings showPasswordSettings={3} setIsEditClicked={setIsEditClicked} />;
        } else {
            return <p>No Settings Available for this User Type</p>;
        }
    };
    const handleEditClick = () => {
        setIsEditClicked(true); // Toggle the state
    };
    return (
        <Card
            sx={{
                borderRadius: 2,
                boxShadow: 1,
                border: '1px solid',
                borderColor: 'grey.100',
                backgroundColor: 'white',
                p: 3,
            }}
        >
            {/* Section Header */}


            <Box sx={{ display: "flex", alignItems: "center", mb: 3 }}>
                <KeyRound size={24} style={{ marginRight: 8, color: "#3b82f6" }} />
                <Typography variant="h6" fontWeight="bold" sx={{ flexGrow: 1 }}>
                    Password & Security
                </Typography>
                <Button onClick={handleEditClick}>
                    <Edit />
                </Button>
            </Box>
            {/* Last Password Change Info */}


            {/* Password Strength */}
            <PasswordStrength strength={80} />

            {/* Password Requirements */}

            {/* Password Requirements */}
            <PasswordRequirements />
            {isEditClicked && (
                <Box sx={{ marginTop: 4 }}>{renderDialogContent()}</Box>
            )}
        </Card>
    );
};

export default PasswordSection;
